// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
export var ExtendedAssetPermission;
(function (ExtendedAssetPermission) {
    ExtendedAssetPermission["ASSET_EXTENDED_PERMISSION_UNKNOWN"] = "ASSET_EXTENDED_PERMISSION_UNKNOWN";
})(ExtendedAssetPermission || (ExtendedAssetPermission = {}));
export var ExtendedAssetPermission_index;
(function (ExtendedAssetPermission_index) {
    ExtendedAssetPermission_index[ExtendedAssetPermission_index["ASSET_EXTENDED_PERMISSION_UNKNOWN"] = 0] = "ASSET_EXTENDED_PERMISSION_UNKNOWN";
})(ExtendedAssetPermission_index || (ExtendedAssetPermission_index = {}));
/**
 * AssetPermission is an enum with the bit positions for the permissions in shrunken form
 */
export var AssetPermission;
(function (AssetPermission) {
    AssetPermission["ASSET_PERMISSION_UNKNOWN"] = "ASSET_PERMISSION_UNKNOWN";
    AssetPermission["READ"] = "READ";
    AssetPermission["WRITE"] = "WRITE";
    AssetPermission["CONFIGURE"] = "CONFIGURE";
    AssetPermission["GRANT"] = "GRANT";
    AssetPermission["DELETE"] = "DELETE";
    AssetPermission["SENSITIVE"] = "SENSITIVE";
})(AssetPermission || (AssetPermission = {}));
export var AssetPermission_index;
(function (AssetPermission_index) {
    AssetPermission_index[AssetPermission_index["ASSET_PERMISSION_UNKNOWN"] = 0] = "ASSET_PERMISSION_UNKNOWN";
    AssetPermission_index[AssetPermission_index["READ"] = 1] = "READ";
    AssetPermission_index[AssetPermission_index["WRITE"] = 2] = "WRITE";
    AssetPermission_index[AssetPermission_index["CONFIGURE"] = 4] = "CONFIGURE";
    AssetPermission_index[AssetPermission_index["GRANT"] = 8] = "GRANT";
    AssetPermission_index[AssetPermission_index["DELETE"] = 16] = "DELETE";
    AssetPermission_index[AssetPermission_index["SENSITIVE"] = 32] = "SENSITIVE";
})(AssetPermission_index || (AssetPermission_index = {}));
